<template>
  <v-app>
    <v-snackbar v-model="snackbar">
      {{ msgRes }}
      <v-btn dark text @click="snackbar = false"> Close </v-btn>
    </v-snackbar>
    <v-toolbar color="primary" :max-height="64" class="toolbar">
      <v-container fluid pa-0 class="my__toolbar">
        <v-row class="align-center justify-center">
          <v-col class="col-3 col-md-5 d-md-none">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  text
                  class="navbar-buttons primary--text justify-start pa-0"
                  color="white"
                  v-on="on"
                >
                  <v-icon size="26">menu</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn
                      text
                      href="https://blog.ondivan.com.br/"
                      target="_blank"
                      class="navbar-buttons primary--text mr-2"
                    >
                      <v-icon class="mr-2">subject</v-icon>{{ $t('publicNavBar.blog') }}
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-btn to="/sobre" text class="navbar-buttons primary--text">
                      <img
                        :src="require('../../assets/icon_ondivan.png')"
                        class="mr-3"
                        style="width: 20px"
                      />
                      Sobre Nós
                    </v-btn>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <a
                      href="/paciente"
                      class="navbar-buttons white primary--text button-anchor f-subtituloSection"
                    >
                      <v-icon class="primary--text mr-2">record_voice_over</v-icon>Sou Paciente
                    </a>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <a
                      href="/psicologo"
                      class="navbar-buttons white primary--text button-anchor f-subtituloSection"
                    >
                      <v-icon class="primary--text mr-2">hearing</v-icon>Sou Psicólogo
                    </a>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col class="col-5 col-md-5 disappear-mobile">
            <v-btn
              href="https://blog.ondivan.com.br/"
              target="_blank"
              color="white"
              class="navbar-buttons primary--text mr-2"
            >
              <v-icon>subject</v-icon>{{ $t('publicNavBar.blog') }}
            </v-btn>
            <v-btn to="/sobre" color="white" class="navbar-buttons primary--text">
              <img
                :src="require('../../assets/icon_ondivan.png')"
                class="mr-2"
                style="width: 20px"
              />
              Sobre Nós
            </v-btn>
          </v-col>
          <v-col class="col-7 col-md-2 offset-1 offset-md-0">
            <v-row class="align-center justify-md-center">
              <img :src="require('../../assets/ondivan_marca_white.svg')" width="70%;" />
            </v-row>
          </v-col>
          <v-col class="col-5 col-md-5 disappear-mobile">
            <v-row class="justify-end">
              <a href="/paciente" class="navbar-buttons white primary--text button-anchor">
                <v-icon class="primary--text mr-2">record_voice_over</v-icon>Sou Paciente
              </a>
              <a href="/psicologo" class="navbar-buttons white primary--text button-anchor">
                <v-icon class="primary--text mr-2">hearing</v-icon>Sou Psicólogo
              </a>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-toolbar>

    <section class="hero-section cover d-flex align-center justify-center" style="height: 300px">
      <h1 class="white--text begin-therapy text-center f-tituloSection">
        Conheça os nossos parceiros
      </h1>
    </section>

    <section style="margin-top: -50px">
      <v-row class="align-center justify-center ma-0">
        <v-col class="col-12 col-md-9 col-xl-7">
          <div class="d-flex flex-column flex-md-row align-center justify-space-around">
            <div
              class="mt-3 mt-md-0 text-center card-box-shadow bg-white pa-4 px-lg-8 d-flex flex-column align-center justify-space-around"
              style="min-height: 370px"
            >
              <img
                :src="require('../../assets/parceiro6.png')"
                style="width: 250px; height: 150px; object-fit: contain"
              />

              <h2 class="ma-0 mt-3 f-14">
                LARANJA MECÂNICA
                <br />FUTSAL CLUBE
              </h2>

              <div class="d-flex flex-column align-center justify-center px-10">
                <v-btn color="secondary" href="https://lmfc.pt" class="w-100 mt-3 primary--white"
                  >Conheça o Parceiro</v-btn
                >
              </div>
            </div>

            <div
              class="mt-3 mt-md-0 text-center card-box-shadow bg-white pa-4 px-lg-8 d-flex flex-column align-center justify-space-around"
              style="min-height: 370px"
            >
              <img
                :src="require('../../assets/parceiro2.png')"
                style="width: 250px; height: 150px; object-fit: contain"
              />
              <h2 class="ma-0 mt-3 f-14">STARTUP TORRES NOVAS</h2>

              <div class="d-flex flex-column align-center justify-center px-10">
                <v-btn
                  link
                  target="blank"
                  href="//startuptorresnovas.pt/index.php/pt-pt/"
                  color="secondary"
                  class="w-100 mt-3 primary--white"
                  >Conheça o Parceiro</v-btn
                >
              </div>
            </div>
          </div>

          <div class="d-flex flex-column flex-md-row align-center justify-space-around">
            <div
              class="mt-3 mt-md-10 text-center card-box-shadow bg-white pa-4 px-lg-8 d-flex flex-column align-center justify-space-around"
              style="min-height: 370px"
            >
              <img
                :src="require('../../assets/parceiro4.png')"
                style="width: 250px; height: 150px; object-fit: contain"
              />

              <h2 class="ma-0 mt-3 f-14">NERSANT</h2>

              <div class="d-flex flex-column align-center justify-center px-10">
                <v-btn
                  link
                  target="blank"
                  href="//nersant.pt/"
                  color="secondary"
                  class="w-100 mt-3 primary--white"
                  >Conheça o Parceiro</v-btn
                >
              </div>
            </div>

            <div
              class="mt-3 mt-md-10 text-center card-box-shadow bg-white pa-4 px-lg-8 d-flex flex-column align-center justify-space-around"
              style="min-height: 370px"
            >
              <img
                :src="require('../../assets/parceiro5.png')"
                style="width: 250px; height: 150px; object-fit: contain"
              />
              <h2 class="ma-0 mt-3 f-14">
                BOMBEIROS VOLUNTÁRIOS
                <br />TORREJANOS
              </h2>

              <div class="d-flex flex-column align-center justify-center px-10">
                <v-btn
                  link
                  target="blank"
                  href="//bombeirostorresnovas.pt"
                  color="secondary"
                  class="w-100 mt-3 primary--white"
                  >Conheça o Parceiro</v-btn
                >
                <v-btn
                  target="_blank"
                  href="https://firebasestorage.googleapis.com/v0/b/ondivan-staging.appspot.com/o/doc%2FContratoBVTN-Ondivan.pdf?alt=media&token=ea988af9-3935-4e63-adbd-46285e5cf0c0"
                  color="secondary"
                  class="w-100 mt-5 primary--white"
                  >Protocolo</v-btn
                >
              </div>
            </div>
          </div>

          <div class="d-flex flex-column flex-md-row align-center justify-space-around">
            <div
              class="mt-3 mt-md-10 text-center card-box-shadow bg-white pa-4 px-lg-8 d-flex flex-column align-center justify-space-around"
              style="min-height: 370px"
            >
              <img
                :src="require('../../assets/parceiro8.png')"
                style="width: 250px; height: 150px; object-fit: contain"
              />

              <h2 class="ma-0 mt-3 f-14">MEDICARE</h2>

              <div class="d-flex flex-column align-center justify-center px-10">
                <v-btn
                  color="secondary"
                  target="blank"
                  href="//www.medicare.pt"
                  class="w-100 mt-3 primary--white"
                  >Conheça o Parceiro</v-btn
                >
              </div>
            </div>

            <div
              class="mt-3 mt-md-10 text-center card-box-shadow bg-white pa-4 px-lg-8 d-flex flex-column align-center justify-space-around"
              style="min-height: 370px"
            >
              <img
                :src="require('../../assets/parceiro7.png')"
                style="width: 250px; height: 150px; object-fit: contain"
              />
              <h2 class="ma-0 mt-3 f-14">RENOVA</h2>

              <div class="d-flex flex-column align-center justify-center px-10">
                <v-btn
                  link
                  target="blank"
                  href="//myrenova.com/pt/pt/"
                  color="secondary"
                  class="w-100 mt-3 primary--white"
                  >Conheça o Parceiro</v-btn
                >
              </div>
            </div>
          </div>

          <h1 class="primary--text begin-therapy text-center f-subtituloSection mt-3 mt-md-10">
            Colaboradores:
          </h1>

          <div class="d-flex flex-column flex-md-row align-center justify-space-around">
            <div
              class="mt-3 mt-md-10 text-center card-box-shadow bg-white pa-4 px-lg-8 d-flex flex-column align-center justify-space-around"
              style="min-height: 370px; max-width: 346px"
            >
              <img
                :src="require('../../assets/parceiro3.png')"
                style="width: 250px; height: 150px; object-fit: contain"
              />

              <h2 class="ma-0 mt-3 f-14">KLUTCH TECNOLOGIA</h2>

              <div class="d-flex flex-column align-center justify-center px-10">
                <v-btn
                  link
                  target="_blank"
                  href="//www.klutch.com.br"
                  color="secondary"
                  class="w-100 mt-3 primary--white"
                  >Conheça o Colaborador</v-btn
                >
              </div>
            </div>

            <div
              class="mt-3 mt-md-10 text-center card-box-shadow bg-white pa-4 px-lg-8 d-flex flex-column align-center justify-space-around"
              style="min-height: 370px; max-width: 346px"
            >
              <img
                :src="require('../../assets/matchmallow.jpeg')"
                style="width: 250px; height: 150px; object-fit: contain"
              />

              <h2 class="ma-0 mt-3 f-14">MATCHMALLOW</h2>

              <div class="d-flex flex-column align-center justify-center px-10">
                <v-btn
                  link
                  target="_blank"
                  href="https://matchmallowdigital.com.br/"
                  color="secondary"
                  class="w-100 mt-3 primary--white"
                  >Conheça o Colaborador</v-btn
                >
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>

    <section class="mt-3 mt-md-10 bg-contato py-3 py-md-7">
      <v-row class="align-center justify-center ma-0">
        <v-col class="col-12 col-md-11">
          <v-row class="align-start justify-center ma-0">
            <v-col class="col-12 col-lg-6 pt-0">
              <div class="pa-3 pt-0 px-md-10">
                <h2
                  class="primary--text begin-therapy text-center text-md-left f-tituloSection mt-3 mt-md-0 mb-3"
                  style="font-weight: 400"
                >
                  Porquê ser parceiro do Ondivan?
                </h2>
                <p class="gray--text text-center text-md-left f-textoCorpoSection">
                  O Ondivan acredita que juntos somos mais fortes, por isso, assinamos/estabelecemos
                  acordos e protocolos com diversas instituições. Além disto, contamos com o apoio
                  de entidades parceiras com o objetivo de prestar serviços de excelência aos nossos
                  clientes. Faça parte da nossa rede!
                </p>
              </div>
            </v-col>
            <v-col class="col-12 col-md-10 col-lg-6 col-xl-5 pa-0">
              <div class="bg-white card-box-shadow br-10 mt-3 mt-md-0 pa-3 pa-md-5 pt-md-8">
                <p class="ma-0 primary--text text-center f-subtituloSection">
                  Deseja ser parceiro ou colaborador?
                </p>
                <p class="ma-0 gray--text text-center f-textoCorpoSection">
                  {{ $t('partners.contact') }}
                </p>

                <v-form v-model="valid" ref="form">
                  <v-container>
                    <v-row class="justify-center">
                      <v-col class="col-12">
                        <v-text-field
                          solo
                          flat
                          label="Nome Completo"
                          required
                          background-color="#F7F7F7"
                          v-model="name"
                          :rules="rules"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          label="Seu Email"
                          required
                          background-color="#F7F7F7"
                          v-model="email"
                          :rules="rules"
                        ></v-text-field>
                        <v-select
                          :items="list_type"
                          label="Selecionar"
                          @change="getType"
                          :rules="rules"
                          required
                          solo
                          flat
                          background-color="#F7F7F7"
                        ></v-select>
                        <v-textarea
                          solo
                          flat
                          filled
                          no-resize
                          rows="12"
                          placeholder="Digite aqui sua mensagem..."
                          v-model="msg"
                          :rules="rules"
                        ></v-textarea>

                        <div style="text-align: right">
                          <v-btn
                            color="secondary"
                            class="primary--white px-10"
                            @click="sendForm()"
                            :loading="isLoading"
                            :disabled="!valid"
                          >
                            Enviar
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </section>
    <v-footer class="footer-section" height="lg:auto" color="primary">
      <v-row class="align-center justify-center ma-0 h-full">
        <v-col class="py-3 text-center white--text col-12 col-md-2" style="font-size: 12px">
          <img :src="require('../../assets/ondivan_marca_white.svg')" width="180px;" />
        </v-col>
        <v-col class="py-3 text-center white--text col-12 col-md-2" style="font-size: 14px">
          <strong>RESPONSÁVEL TÉCNICO:</strong>
          <br />Inês Mata {{ $t('footer.opp') }}
        </v-col>
        <v-col
          class="py-3 d-flex text-center align-center justify-space-around col-12 col-md-2"
          style="font-size: 14px"
        >
          <div v-if="lang === 'pt'">
            <a href="https://www.livroreclamacoes.pt/" target="_blank" class="white--text"
              >Livro de Reclamações</a
            >
          </div>
          <div>
            <a href="/privacidade" class="white--text">Política de privacidade</a>
          </div>
        </v-col>
        <v-col class="py-3 text-center col-12 col-md-2" style="font-size: 14px">
          <a target="blank" href="https://fb.me/ondivan.net">
            <img :src="require('../../assets/facebook_icon.png')" width="40px;" />
          </a>
          <a target="blank" href="https://www.instagram.com/on.divan/">
            <img :src="require('../../assets/instagram_icon.png')" width="40px;" class="ml-4" />
          </a>
        </v-col>
        <v-col
          class="pa-3 row text-center col-12 col-md-2 align-center d-flex"
          style="font-size: 12px"
        >
          <div class="d-flex row align-center justify-center">
            <div>
              <p class="mb-1 mr-1 white--text" style="font-size: 1.2rem">
                <strong>Email:</strong>geral@ondivan.net
              </p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import PartnerService from '../../services/general';
import getLanguage from '../../utils/getLanguage';

export default {
  data() {
    return {
      valid: false,
      name: '',
      email: '',
      list_type: [
        {
          text: 'Parceiro',
          value: 'partner',
        },
        {
          text: 'Colaborador',
          value: 'collaborator',
        },
      ],
      type: '',
      msg: '',
      snackbar: false,
      msgRes: '',
      isLoading: false,
      rules: [(v) => !!v || 'Esse campo é obrigatório'],
      lang: '',
    };
  },

  created() {
    this.lang = getLanguage(window.location.href);
  },
  methods: {
    async sendForm() {
      try {
        this.isLoading = true;
        const response = await PartnerService.sendPartner(
          this.name,
          this.email,
          this.type,
          this.msg,
        );
        if (response.status === 204) {
          this.snackbar = true;
          this.msgRes = 'Email enviado com sucesso!';
          // this.name = '';
          // this.email = '';
          // this.msg = '';
          this.$refs.form.reset();
        } else {
          this.snackbar = true;
          this.msgRes = 'Ocorreu um erro, tente novamente mais tarde!';
        }
        console.log(response);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    getType(v) {
      this.type = v;
    },
  },
};
</script>

<style lang="css" scoped>
* >>> .v-carousel {
  box-shadow: none !important;
}

* >>> .v-carousel__controls {
  background: rgba(0, 0, 0, 0) !important;
}

* >>> .v-carousel__controls__item .v-btn__content .v-icon {
  color: #93291e;
}

.navbar-buttons {
  justify-content: start;
  margin: 0;
}

/* .bg-contato:after {
  content: '';
  height: 100%;
  display: block;
} */

.box-form-contato {
  border-radius: 0 10px 10px 10px;
}

.colaborator-div {
  max-width: 346px;
  min-height: 370px;
}

@media screen and (max-width: 420px) {
  .bg-contato,
  .box-form-contato {
    border-radius: 10px;
  }
}

.form-contato {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  overflow: auto;
}

.button-anchor {
  border-radius: 8px;
  text-transform: uppercase;
  font-weight: 500;
  height: 36px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  text-decoration: none;
  margin: 0px 5px;
}

.toolbar {
  height: auto;
}

.v-toolbar__content {
  height: auto !important;
}

.my__toolbar {
  height: auto;
}

.hero-section {
  background: linear-gradient(rgba(160, 23, 23, 0.49), rgba(124, 41, 30, 0.5)),
    url(../../assets/imagem2.png) no-repeat;
  background-position: center;
  background-size: cover;
}

@media screen and (max-width: 420px) {
  * >>> .carousel-entrevistas .v-window__prev,
  * >>> .carousel-entrevistas .v-window__next {
    display: none !important;
  }

  .v-menu--inline {
    display: none !important;
  }

  .disappear-mobile {
    display: none;
  }

  .navbar-buttons {
    font-size: 10px;
    justify-content: start;
    margin: 0;
  }
}

@media screen and (max-width: 1024px) {
  .colaborator-div {
    max-width: 316px;
  }

  .footer-section {
    min-height: 50vh;
  }
}
</style>
